export default __webpack_public_path__ + "static/media/load.2ee730b9.gif";